import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class NoticeService {
  constructor(private http: HttpClient) {}

  public query(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/notices`;
    return this.http.get(url, { params });
  }

  public first(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/notices/first`;
    return this.http.get(url, { params }).pipe(map((data: any) => data.notice));
  }

  public last(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/notices/last`;
    return this.http.get(url, { params }).pipe(map((data: any) => data.notice));
  }

  public get(params: any) {
    let groupId: any;
    let noticeId: any;
    let projectId: any;
    [params, projectId, groupId, noticeId] = splayParams(
      params,
      "projectId",
      "groupId",
      "noticeId",
    );
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/notices/${noticeId}`;
    return this.http.get(url, { params });
  }

  public prev(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/notices/previous`;
    return this.http.get(url, { params }).pipe(map((data: any) => data.notice));
  }

  public next(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    const url = `/api/v4/projects/${projectId}/groups/${groupId}/notices/next`;
    return this.http.get(url, { params }).pipe(map((data: any) => data.notice));
  }
}
